site.multiform = {
	init: function () {
		site.multiform.resize();
		$(window).resize(function() {
			site.multiform.resize();
		});

		var $select = '#multiform .select';
		$('label', '#multiform').inFieldLabels();
		$('a', $select).on('click', function(e) {
			e.preventDefault();
			var $li = $('li', $select),
				$selected = $(this).closest('li'),
				codename = $selected.data('codename'),
				divisionCodename = $selected.data('division');
			$li.removeClass('selected');
			$selected.addClass('selected');

			$.ajax({
				url: divisionCodename+'/moya/multiform/'+codename,
				type: 'get'
			}).done(function(r) {
				var $container = $('#formContainer');

				$container.html(r);
				$('label',$container).inFieldLabels();
				site.multiform.resize();
			});
		});
	},

	resize: function() {
		var $container = $('#formContainer'),
			textareaHeight = $container.outerHeight(true) - $('.elm_controls', $container).outerHeight(true) - 11;
		if ($(window).width() + 15 > 768) {
			$('textarea', $container).css('min-height', textareaHeight);
		}
		else {
			$('textarea', $container).removeAttr('style');
		}
	},

	admin: function() {
		$.localise('ui-multiselect', {language: moya.lang, path: '/_moya/js/jquery/multiselect/js/locale/'});
		$('#forms').multiselect({
			sortable: true,
			searchable: false,
		});
	},
};
